module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/components/gallery/clipart/clipart.component.scss
// module id = ./src/app/components/gallery/clipart/clipart.component.scss
// module chunks = main